import {Injectable} from '@angular/core';
import {Headers, Http, RequestOptions, Response, URLSearchParams} from '@angular/http';
import * as _ from "lodash";
import 'rxjs/add/operator/map';
import {Observable} from "rxjs/Observable";
import {Page} from "../../shared/pager/page";


@Injectable()
export class BookingService {

    private baseUrl: string = '../rest/company/';
    private endpoint:string = 'booking';

    constructor(private http : Http) {}

    getData(): any {
        return Observable.forkJoin([
            this.getBookingStatus(),
            this.getBookingDateType(),
            this.getPaymentMethods(),
            this.getPlaceOfPurchase()
        ]);
    }

    private getPlaceOfPurchase() {
        return this.http
            .get(`../rest/geo/countries`, { headers: this.getHeaders()})
            .map((response) => this.mapCountriesResponse(response));
    }

    private getBookingStatus(): Observable<string[]> {
        return this.http
            .get(`../rest/data/bookingsStatus`, { headers: this.getHeaders()})
            .map((response) => this.mapActions(response, 'booking.status.'));
    }

    private getBookingDateType(): Observable<string[]> {
        return this.http
            .get(`../rest/data/dateTypes`, { headers: this.getHeaders()})
            .map((response) => this.mapActions(response, 'booking.dataType.'));
    }

    private getPaymentMethods(): Observable<string[]> {
        return this.http
            .get(`../rest/data/paymentMethods`, { headers: this.getHeaders()})
            .map((response) => this.mapActions(response, 'booking.paymentMethod.'));
    }

    getByCompany(companyId:number, filter:any, pageNumber:number): Observable<Page> {
        let myParams = this.getBookingRequestParams(filter, pageNumber);
        let options = new RequestOptions({ headers: this.getHeaders(), search:myParams });
        return this.http
            .get(`${this.baseUrl}${companyId}/${this.endpoint}`, options)
            .map((response) => this.mapPage(response));
    }

    get(filter:any, pageNumber:number): Observable<Page> {
        let myParams = this.getBookingRequestParams(filter, pageNumber);
        let options = new RequestOptions({ headers: this.getHeaders(), search:myParams });
        return this.http
            .get(`${this.baseUrl}${this.endpoint}`, options)
            .map((response) => this.mapPage(response));
    }

    private mapActions(response:Response, message): string[]{
        let body = response.json();
        return _.map(body, (item) => {return {value:message+item, text:item}}) || [];
    }

    private mapCountriesResponse(response:Response): string[]{
        let body = response.json();
        return _.map(body, (item) => {return {code:item.code, description:item.descriptions.es}}) || [];
    }

    private getHeaders(){
        let myHeaders = new Headers();
        myHeaders.append('Content-Type', 'application/json');
        return myHeaders;
    }

    getOne(companyOid, bookingOid){
        return this.http
            .get(`${this.baseUrl}${companyOid}/${this.endpoint}/${bookingOid}`, { headers: this.getHeaders()})
            .map((response) => response.json());
    }

    getVcc(companyOid, oid){
        return this.http
            .get(`${this.baseUrl}${companyOid}/${this.endpoint}/${oid}/vcc`, { headers: this.getHeaders()})
            .map((response) => response.json())
    }

    performNoShow(companyOid, oid){
        return this.http
            .get(`${this.baseUrl}${companyOid}/${this.endpoint}/${oid}/noShow`, { headers: this.getHeaders()})
            .map((response) => response.json())
    }

    markAsRead(companyOid, oid, mark) {
        return this.http
            .patch(`${this.baseUrl}${companyOid}/${this.endpoint}/${oid}/mark-as-read`, { read: mark}, { headers: this.getHeaders()})
            .map((response) => response.json())
    }

    private mapBooking(response: any):Booking {
        return response.json()
    }

    private mapPage(response: any):Page {
        return response.json()
    }

    private getBookingRequestParams(filter: any, pageNumber: number) {
        let myParams = new URLSearchParams();
        myParams.append('pageNumber', pageNumber.toString());

        for (let key of Object.keys(filter)) {
            myParams.append(key, filter[key]);
        }
        return myParams;
    }
}



// WEBPACK FOOTER //
// ./public/upgrade/feature/booking/booking.service.ts